<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>

<div mat-dialog-content>
  <div class="integration-dialog-content-width">
    <div *ngIf="creating" class="int-text-container">
      <span class="step-label">Step 1:</span>
      <span class="step-text">
        {{description}}
      </span>
    </div>

    <div *ngIf="creating" class="int-text-container">
      <span class="step-label">Step 2:</span>
      <span class="step-text">
        Log into your Facebook Account and go to the "Ad Account" tab in Business Manager
      </span>
    </div>

    <div *ngIf="creating" class="int-text-container">
      <span class="step-label">Step 3:</span>
      <span class="step-text">
        Click "Assign Partner", enter the Account ID <a (click)="copy()" matTooltip="Copy to clipboard">{{advocadoAccountId}}</a>, and select a role.
      </span>
    </div>

    <div fxLayout="row" fxLayoutAlign="center">
      <div
              *ngIf="creating"
              class="fb-login-button"
              data-width=""
              data-size="large"
              data-button-type="continue_with"
              data-scope="ads_read,ads_management,business_management"
              data-auto-logout-link="true"
              data-use-continue-as="true"
      ></div>
    </div>

    <mat-form-field *ngIf="creating && adAccounts.length">
      <mat-select placeholder="Select an Ad Account" [disabled]="!loggedin" [(ngModel)]="adAccount">
        <mat-option *ngFor="let account of adAccounts" [value]="account.account_id">
          {{ account.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div *ngIf="isAdmin && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Account Name: {{ int.friendlyName }}</div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>CANCEL</button>
    <button mat-raised-button color="primary" (click)="done()" *ngIf="!connecting" [disabled]="!adAccount">
      CONNECT
    </button>
    <span class="loading-spinner" *ngIf="connecting">
      <mat-progress-spinner mode="indeterminate" [diameter]="35"></mat-progress-spinner>
    </span>
  </div>
</div>
